import { Suspense } from 'react'
import Loading from '@/components/shared/Loading'
import AllRoutes from '@/components/route/AllRoutes'
import { useLocation } from 'react-router'
import type { LayoutType } from '@/@types/theme'

interface ViewsProps {
    pageContainerType?: 'default' | 'gutterless' | 'contained'
    layout?: LayoutType
}

const Views = (props: ViewsProps) => {
    const location = useLocation()

    // Keyed on the path, not location.key: location.key changes on every
    // navigation, including a query change like ?tab=convert, and remounting
    // the whole page on that threw away what the author had typed or picked
    // (the ePub Convert tab lost its document search the moment the tab
    // wrote its name into the URL). A new page — a new path — still gets a
    // fresh mount and its own Suspense boundary.
    return (
        <Suspense
            key={location.pathname}
            fallback={<Loading loading={true} className="w-full" />}
        >
            <AllRoutes {...props} />
        </Suspense>
    )
}

export default Views
